import type { SceneControl } from '@anov/3d-core'
import { Object3D } from '@anov/3d-core'
import _ from 'lodash'

/**
 * 覆盖物的基础类，如：POI、样条线、3D柱状图、热力图等
 */
class ObjectLayer extends Object3D {
  type = 'Group'
  protected sceneControl: SceneControl

  constructor(sceneControl: SceneControl) {
    super()
    this.sceneControl = sceneControl
  }

  // 创建代理对象的工具方法
  public createProxy<T extends object>(obj: T, mesh: Object3D, fn: Function | null = null): T {
    return new Proxy(obj, {
      set: (target, prop, value) => {
        if (mesh)
          // @ts-ignore
          mesh[prop] = value
        // @ts-ignore
        target[prop] = value
        fn && fn(prop, value)
        return true
      },
    })
  }

  arrayMergeCustomizer(objValue: any, srcValue: any) {
    if (_.isArray(objValue) && srcValue)
      return srcValue
  }

  destroy() {

  }
}

export default ObjectLayer
